import { render } from "./PesquisaView.vue?vue&type=template&id=52e88206"
import script from "./PesquisaView.vue?vue&type=script&lang=js"
export * from "./PesquisaView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__